const Loading = () => {
  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <div className="border-gray-300 h-20 w-20 rounded-full border-8 border-t-blue-600 animate-spin"></div>
    </div>
  );
};

export default Loading;
